import { useEffect } from 'react'

import { SEC } from '@/util/formatters/dates'

import { useMountEffect } from './mounting-hooks'

export const useInterval = (callback = () => {}, timeout = 5 * SEC) => {
  useMountEffect(() => {
    callback()
  })

  useEffect(() => {
    const id = setInterval(callback, timeout)
    return () => clearInterval(id)
  }, [callback, timeout])
}
